<template>
  <div>
    <users-table striped hover></users-table>
  </div>
</template>

<script>
import UsersTable from './UsersTable'

export default {
  name: 'users',
  components: {
    UsersTable
  }
}
</script>
